export default {"src":"/_next/static/media/wishlist_header.a344a951.svg","height":24,"width":26,"blurWidth":0,"blurHeight":0};